import { render, staticRenderFns } from "./CategoriesBeta.vue?vue&type=template&id=fabe5a5c&scoped=true"
import script from "./CategoriesBeta.vue?vue&type=script&lang=js"
export * from "./CategoriesBeta.vue?vue&type=script&lang=js"
import style0 from "./CategoriesBeta.vue?vue&type=style&index=0&id=fabe5a5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabe5a5c",
  null
  
)

export default component.exports